module.exports = __webpack_public_path__ + "img/shadow_ancient_small.2f6cd22e.png";